import React, {useEffect, useState, useRef} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames/bind'
import PropTypes from 'prop-types'

import { hideBodyScroll, showBodyScroll } from '../search/utils'
import { closePopup } from '../PopupConstructor/actions/popupActions'

import styles from './PopupRedesign.module.scss'

const cx = classnames.bind(styles)

export const CloseButton = ({className, onClick}) => (
  <button
    type="button"
    className={cx('close', className)}
    onClick={onClick}
  >
    <i aria-hidden={true} className={cx('close-icon', 'icon-modal-close')}/>
    Close
  </button>
)

/**
 * <PopUp>
 *   Write your html here.
 * </PopUp>
 */
const PopUp = function (props) {
  const {
    className,
    isCloseBtn = true,
    closeClassName,
    bodyClassName,
    children,
    theme = 'default',
    onClose,
    useScrollBack = true,
    onCloseAction,
    autoFocus = true,
  } = props;
  const [scrollTop, setScrollTop] = useState(window.pageYOffset)
  const modalWrapRef = useRef(null)
  const toglerElement = window.document.activeElement;

  useEffect(() => {
    hideBodyScroll()
    if (autoFocus) {
      focusElement(true)
    }
    window.addEventListener('keydown', onKeyDown)

    return () => {
      window.removeEventListener('keydown', onKeyDown)
      showBodyScroll()
      if (useScrollBack && scrollTop) {
        window.scrollTo(0, scrollTop)
      }
      toglerElement?.focus();
    }
  }, []);

  const onKeyDown = function (e) {
    if (e.keyCode === 27) {
      handleCloseClick()
    }
  }

  const getKeyboardFocusableElements = function (element) {
    const elements = element.querySelectorAll(
      'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
    )
    return [...elements].filter(el => {
      return !el.hasAttribute('disabled')
        && !el.getAttribute('aria-hidden')
        && (el.getAttribute('tabindex') !== '-1')
    })
  }

  const handleCloseClick = () => {
    onClose ? onClose(onCloseAction) : onCloseAction()
  }

  const focusElement = function (isFirst) {
    const possibleElements = getKeyboardFocusableElements(modalWrapRef.current);
    const element = isFirst ? possibleElements[0] : possibleElements[possibleElements.length - 1]
    element?.focus({focusVisible: false})
  }

  return (
    <div className={cx('root', `theme--${theme}`)}>
      <span aria-hidden={true} onFocus={() => focusElement(false)} tabIndex={0} />
      <div className={cx('popup', className)} ref={modalWrapRef}>
        <div className={cx('navigation')}>
          {isCloseBtn && (<CloseButton className={cx('close-btn', closeClassName)} onClick={handleCloseClick}/>)}
        </div>
        <div className={cx('popup__content', bodyClassName)}>
          {children}
        </div>
      </div>
      <div onClick={handleCloseClick} className={cx('background-layer')} />
      <span aria-hidden={true} onFocus={() => focusElement(true)} tabIndex={0} />
    </div>
  )
}

PopUp.propTypes = {
  onCloseAction: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['full', 'mobile-full', 'default', 'sticky-lath']),
  closeClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  className: PropTypes.string,
  isCloseBtn: PropTypes.bool,
  autoFocus: PropTypes.bool,
  useScrollBack: PropTypes.bool,
}

export default connect(() => ({}),
  dispatch => ({
    onCloseAction: () => dispatch(closePopup()),
  }))(PopUp)
